import * as React from "react";
import type { SVGProps } from "react";
const SvgHouses = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#houses_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.71 2.29a.996.996 0 0 0-1.41 0l-7.01 7A1 1 0 0 0 0 10v11c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-5h2v5c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V10c0-.27-.11-.52-.29-.71zM14 20h-3v-5c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v5H2v-9.59l6-6 6 6zM12.71 2.29A.996.996 0 1 0 11.3 3.7l6.71 6.71V21c0 .55.45 1 1 1s1-.45 1-1V10c0-.27-.11-.52-.29-.71zm4 0 7 7h.01c.18.19.29.44.29.71v11c0 .55-.45 1-1 1s-1-.45-1-1V10.41L15.3 3.7a.996.996 0 1 1 1.41-1.41"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="houses_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHouses;
